export async function jsonFetch<T>(
  url: string,
  options?: RequestInit
): Promise<T | undefined> {
  const response = await fetch(url, options);

  if (!response.ok) {
    let errorBody;
    try {
      // try to parse error code from body
      const body = await response.json();
      errorBody = JSON.stringify(body);
    } catch (error) {
      // ignore json error
    }

    throw new Error(
      `Failed to fetch ${url}! Status: ${response.status}, ${
        errorBody ?? response.statusText
      }`
    );
  }

  try {
    const data: T = await response.json();
    const apiResponse = {
      data,
      status: response.status,
      statusText: response.statusText,
    };

    return apiResponse.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error("JSON Parsing Error:", error.message);
      throw error;
    }
  }
}
